module.exports = __webpack_public_path__ + "static/media/books.4ea07472.png";